import { Link, useNavigate } from "react-router-dom";
import tableClass from "../../Table/Table.module.css";
import classes from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useContext, useState, useEffect } from "react";
import authContext from "../../../../AuthContext/authContext";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import appActions from "../../../../ReduxStore/appDataSlice";

const base_url = process.env.REACT_APP_BASE_URL;

const AddNewGuard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  console.log(activeLocation,"activeLocation");
  const [locationList, setLocationList] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(true);
  const [guardCount, setGuardCount] = useState(0);
  console.log(guardCount,"guardCount");
  const showDirectory = useSelector(
    (state) => state.appData.showEmployeeDirectory
  );
  const ctx = useContext(authContext);
  const userType = ctx.userData.user_type;
  const [IsDisabled, setIsDisabled] = useState(false);
  // console.log(userType,"userType");
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const nameRegExp = /^[A-Za-z ]+$/;
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      password: "",
      location: activeLocation?.location || "",
      location_id: activeLocation?._id || ""
    },
    
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Please enter employee name"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Please enter email address"),
      phone: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid")
        .length(10, "Phone number should be of 10 digits")
        .required("Please enter your phone number"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Please enter a password")
        
    }),
    onSubmit: (values) => {
      console.log(values,"values");
      setIsDisabled(true);
      if (guardCount >= 3) {
        toast.error("Maximum of 3 guards allowed per location");
        setIsDisabled(false);
        return;
      }
      if (!activeLocation._id || activeLocation.location === "All") {
        toast.error("Please select a location");
        setIsDisabled(false);
        return;
      }

      let reqObj = {
        method: "POST",
        url: `${base_url}/auth/register`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ctx.token}`
        },
        data: {
          name: values.name,
          email: values.email,
          phone: values.phone,
          password: values.password,
          location: activeLocation.location,
          company_id: activeCompany._id,
          location_id: activeLocation._id,
          user_type: "guard"  
        }
      };
      axios(reqObj)
        .then((res) => {
          formik.resetForm();
          toast.dismiss();
          toast.success("Guard created successfully");
          setIsDisabled(false);
          navigate("/guard");
        })
        .catch((err) => { 
          console.log(err);
          toast.dismiss();
          toast.error(
            err.response.data.error.message || "Failed to create guard"
          );
          setIsDisabled(false);
        });
    }
  });

  // const showEmployeeDirectory =
  //   userType == "Company Manager" || userType !== "location"
  //     ? showDirectory
  //     : true;
  let showEmployeeDirectory = "";
  if (userType == "Company Manager" || userType == "location" || userType == "guard"    ) {
    showEmployeeDirectory = showDirectory;
  } else {
    showEmployeeDirectory = true;
  }
  const showLocation = userType !== "location";

  // Fetch locations when component mounts or activeCompany changes
  useEffect(() => {
    const fetchLocations = async () => {
      if (!activeCompany?._id) return;
      
      try {
        setLoadingLocations(true);
        const response = await axios.get(
          `${base_url}/visitor/company/location/${activeCompany._id}`,
          {
            headers: {
              Authorization: `Bearer ${ctx.token}`
            }
          }
        );
        setLocationList(response.data?.location || []);
        
        // If there's an active location, fetch its guard count
        if (activeLocation?._id) {
          await fetchGuardCount(activeLocation._id);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        toast.error("Failed to load locations");
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchLocations();
  }, [activeCompany, ctx.token, activeLocation]);

  const fetchGuardCount = async (locationId) => {
    try {
      const response = await axios.get(
        `${base_url}/auth/guards/list/${locationId}`,
        {
          headers: {
            Authorization: `Bearer ${ctx.token}`
          }
        }
      );
      console.log(response.data,"response.data");
      setGuardCount(response.data?.length || 0);
    } catch (error) {
      console.error("Error fetching guard count:", error);
      setGuardCount(0);
    }
  };

  const handleLocationChange = async (e, { value }) => {
    const selectedLocation = locationList.find(loc => loc._id === value);
    if (selectedLocation) {
      dispatch(
        appActions.setActiveLocation({
          _id: selectedLocation._id,
          location: selectedLocation.location
        })
      );
      // Update formik values when location changes
      formik.setFieldValue('location', selectedLocation.location);
      formik.setFieldValue('location_id', selectedLocation._id);
      
      // Fetch guard count for the selected location
      await fetchGuardCount(selectedLocation._id);
    }
  };

  return (
    <>
      <div className={classes.mainCont}>
        <h3>{!showLocation ? "Add Guard for " + activeLocation.location : "Add Guard"}</h3>
        <div className={classes.topLinks}>
          {showEmployeeDirectory && (
            <div className={tableClass.tableAction}>
              <Link to="/guardDirectory">
                <img
                  src={require("../../../../assets/img/admin-images/copy.png")}
                />
                <span>  Guard Directory</span>
              </Link>
            </div>
          )}
          {showLocation && (
            <div className={tableClass.tableAction} style={{ minWidth: '250px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                  src={require("../../../../assets/img/admin-images/company_black.png")}
                  alt="location"
                  style={{ width: '20px', height: '20px' }}
                />
                <Dropdown
                  placeholder={userType === "Company Manager" ? "Select Location" : "Select Company"}
                  loading={loadingLocations}
                  options={[
                    ...locationList.map(loc => ({
                      key: loc._id,
                      value: loc._id,
                      text: loc.location
                    }))
                  ]}
                  value={activeLocation?._id || ''}
                  onChange={handleLocationChange}
                  style={{ minWidth: '180px' }}
                  selection
                  fluid
                />
                <Link to="/location" style={{ marginLeft: '8px' }}>
                  <span>Manage</span>
                </Link>
              </div>
            </div>
          )}
        </div>

        <form className={classes.FormDiv} onSubmit={formik.handleSubmit}>
          {/* Hidden location fields for form validation */}
          <input type="hidden" name="location" value={formik.values.location} />
          <input type="hidden" name="location_id" value={formik.values.location_id} />
          
          {/* Show error if location is not selected */}
          {formik.touched.location_id && formik.errors.location_id && (
            <div className={classes.errorText} style={{ color: 'red', marginBottom: '15px' }}>
              {formik.errors.location_id}
            </div>
          )}
          
          <div className={classes.formGrp}>
            <label htmlFor="name">Guard Name:</label>

            <div>
              <input
                type="text"
                id="name"
                name="name"
                {...formik.getFieldProps("name")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.name && formik.errors.name ? (
                  <div>{formik.errors.name}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formGrp}>
            <label for="email">Guard Email:</label>
            <div>
              <input
                type="text"
                id="email"
                name="email"
                {...formik.getFieldProps("email")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.email && formik.errors.email ? (
                  <div>{formik.errors.email}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formGrp}>
            <label for="phone">Guard Phone: </label>
            <div>
              <input
                type="text"
                id="phone"
                name="phone"
                {...formik.getFieldProps("phone")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.phone && formik.errors.phone ? (
                  <div>{formik.errors.phone}</div>
                ) : null}
              </span>
            </div>
          </div>

          <div className={classes.formGrp}>
            <label htmlFor="password">Password: </label>
            <div>
              <input
                type="password"
                id="password"
                name="password"
                {...formik.getFieldProps("password")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.password && formik.errors.password ? (
                  <div>{formik.errors.password}</div>
                ) : null}
              </span>
            </div>
          </div>
        <div className={classes.formBtn}>
          <Link to="/guard">
            <button type="button" className={classes.cancleBtn}>
              Cancel
            </button>
          </Link>
          <button 
            type="submit" 
            className={classes.createBtn} 
            disabled={IsDisabled || !formik.isValid}
          >
            {IsDisabled ? "Creating..." : "Create"}
          </button>
        </div>
      </form>
    </div>
  </>
);
};

export default AddNewGuard;
